/**
 * @desc 分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.logisticsCycleInfo.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/logisticsCycleInfo/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
